import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './EntrantsTeamsEsportsRunning.css';

const REFRESH_ICON = '\u21BB'; // Clockwise arrow
const PAUSE_ICON = '\u25A0'; // Black square
const PLAY_ICON = '\u25B6'; // Play symbol

// Placeholder component for displaying Esports entrants/teams in Running state
const EntrantsTeamsEsportsRunning = ({ 
  contest, 
  currentUsername, 
  onTeamSelect, 
  onRefreshData,
  isAutoRefreshEnabled,
  onToggleAutoRefresh,
  refreshError 
}) => {
  // Add countdown state
  const [countdown, setCountdown] = useState(60);

  // Reset countdown when auto-refresh is toggled
  useEffect(() => {
    if (isAutoRefreshEnabled) {
      setCountdown(60);
    }
  }, [isAutoRefreshEnabled]);

  // Handle countdown and refresh
  useEffect(() => {
    let timer;
    if (isAutoRefreshEnabled) {
      if (countdown > 0) {
        timer = setInterval(() => {
          setCountdown(prev => prev - 1);
        }, 1000);
      } else {
        // When countdown hits 0, trigger refresh and reset countdown
        onRefreshData();
        setCountdown(60);
      }
    }
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [isAutoRefreshEnabled, countdown, onRefreshData]);

  // TODO: Implement logic to display Esports teams/entrants and handle selection
  // console.log("EntrantsTeamsEsportsRunning loaded for contest:", contest);

  // Placeholder rendering
  return (
    <div className="entrants-teams-container entrants-teams-container-esports">
      <div className="entrants-teams-header">
        <span className="header-title-group">
          <h3>Esports Teams</h3>
          {refreshError && (
            <span className="header-error-text">Refresh failed: {refreshError}</span>
          )}
        </span>
        <div className="header-buttons">
          <span className="auto-refresh-text">
            Auto-refresh: <span className="countdown-text">{isAutoRefreshEnabled ? `${countdown}s` : 'off'}</span>
          </span>
          <button 
            onClick={onToggleAutoRefresh} 
            className={`refresh-button ${isAutoRefreshEnabled ? 'paused' : ''}`}
            title={isAutoRefreshEnabled ? "Pause Auto-refresh" : "Resume Auto-refresh"}
          >
            {isAutoRefreshEnabled ? PAUSE_ICON : PLAY_ICON}
          </button>
          <button 
            onClick={onRefreshData} 
            className="refresh-button" 
            title="Manual Refresh"
          >
            {REFRESH_ICON}
          </button>
        </div>
      </div>
      <p>Display Esports team list here.</p>
      {/* Example of how selection might work:
      {contest.entrants?.map((entrant) => (
        <div key={entrant.entryName} onClick={() => onTeamSelect(entrant)}>
          {entrant.entryName} {entrant.username === currentUsername ? '(You)' : ''}
        </div>
      ))}
      */}
    </div>
  );
};

EntrantsTeamsEsportsRunning.propTypes = {
  contest: PropTypes.object.isRequired,
  currentUsername: PropTypes.string,
  onTeamSelect: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
  isAutoRefreshEnabled: PropTypes.bool.isRequired,
  onToggleAutoRefresh: PropTypes.func.isRequired,
  refreshError: PropTypes.string,
};

export default EntrantsTeamsEsportsRunning; 